module.exports = __webpack_public_path__ + "az.180d55a6738644db6162.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/az.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/az.svg
// module chunks = styles